export const formatDateSafe = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '-';
  if (/^\d{2}\/\d{2}\/\d{4}/.test(dateStr)) return dateStr;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
};

export const formatDataComprovanteReceita = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '-';
  
  const timeDateMatch = dateStr.match(/(?:(?:às|as)\s+)?(\d{1,2}):(\d{2})(?::(\d{2}))?.*?(?:do dia|de)?.*?(\d{2})\/(\d{2})\/(\d{4})/i);
  if (timeDateMatch) {
    const [, hour, min, sec, day, month, year] = timeDateMatch;
    const d = new Date(0);
    d.setUTCFullYear(Number(year), Number(month) - 1, Number(day));
    d.setUTCHours(Number(hour), Number(min), sec ? Number(sec) : 0, 0);
    if (!isNaN(d.getTime())) {
      return d.toLocaleString('pt-BR', { timeZone: 'UTC' });
    }
  }

  // Trata formato inverso: DD/MM/YYYY ... HH:mm[:ss]
  const dateTimeMatch = dateStr.match(/(\d{2})\/(\d{2})\/(\d{4}).*?(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (dateTimeMatch) {
    const [, day, month, year, hour, min, sec] = dateTimeMatch;
    const d = new Date(0);
    d.setUTCFullYear(Number(year), Number(month) - 1, Number(day));
    d.setUTCHours(Number(hour), Number(min), sec ? Number(sec) : 0, 0);
    if (!isNaN(d.getTime())) {
      return d.toLocaleString('pt-BR', { timeZone: 'UTC' });
    }
  }

  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleString('pt-BR', { timeZone: 'UTC' });
};

export const formatCurrencySafe = (val: string | number | null | undefined): string => {
  if (val === null || val === undefined || val === '') return 'R$ 0,00';
  let num = val;
  if (typeof val === 'string') {
    num = Number(val.replace(/\./g, '').replace(',', '.'));
  }
  if (isNaN(Number(num))) return 'R$ 0,00';
  return Number(num).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const formatDocument = (doc: string, isPF: boolean): string => {
  const raw = doc.replace(/[^A-Za-z0-9]/g, '');
  if (isPF) {
    return raw.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }
  return raw.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, "$1.$2.$3/$4-$5");
};

export const formatCep = (cep: string | null | undefined): string => {
  if (!cep) return '-';
  const raw = cep.replace(/\D/g, '');
  return raw.replace(/(\d{5})(\d{3})/, "$1-$2");
};

export const formatPhone = (ddd: string | number | undefined, tel: string | undefined): string => {
  if (!tel) return '-';
  const cleanTel = String(tel).replace(/\D/g, '');
  const formattedTel = cleanTel.replace(/(\d{4,5})(\d{4})/, "$1-$2");
  return ddd ? `(${ddd}) ${formattedTel}` : formattedTel;
};

export const formatCnae = (cnae: string | number | null | undefined): string => {
  if (!cnae) return '';
  const clean = String(cnae).replace(/\D/g, '');
  if (clean.length === 7) {
    return `${clean.slice(0, 4)}-${clean.slice(4, 5)}/${clean.slice(5, 7)}`;
  }
  if (clean.length === 5) {
    return `${clean.slice(0, 4)}-${clean.slice(4, 5)}`;
  }
  return String(cnae);
};

export const formatNaturezaJuridica = (nat: string | number | null | undefined): string => {
  if (!nat) return '';
  const clean = String(nat).replace(/\D/g, '');
  if (clean.length === 4) {
    return `${clean.slice(0, 3)}-${clean.slice(3, 4)}`;
  }
  return String(nat);
};

export const getCnaeDisplay = (cnae?: string | number | null, descricao?: string | null): string => {
  if (!cnae && !descricao) return '-';
  if (!cnae) return descricao || '-';
  if (!descricao) return formatCnae(cnae);

  const formattedCnae = formatCnae(cnae);
  const rawCnae = String(cnae).replace(/\D/g, '');

  if (descricao.includes(formattedCnae) || (rawCnae && descricao.replace(/\D/g, '').startsWith(rawCnae))) {
    return descricao;
  }

  return `${formattedCnae} - ${descricao}`;
};

export const cleanDocument = (doc?: string | null): string => {
  return (doc || '').replace(/[^A-Za-z0-9]/g, '');
};

export const isPessoaFisica = (doc: string): boolean => {
  const clean = cleanDocument(doc);
  return !/[A-Z]/i.test(clean) && clean.length <= 11;
};
